document.addEventListener("DOMContentLoaded", function () {

    // ==========================
    // Delivery Date
    // ==========================

    function formatDate(date) {
        const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        return months[date.getMonth()] + " " + date.getDate();
    }

    const today = new Date();

    const orderDate = new Date(today);

    const transitStart = new Date(today);
    transitStart.setDate(today.getDate() + 1);

    const transitEnd = new Date(today);
    transitEnd.setDate(today.getDate() + 2);

    const deliveryDate = new Date(today);
    deliveryDate.setDate(today.getDate() + 3);

    const orderDateEl = document.getElementById("order-date");
    const transitDateEl = document.getElementById("transit-date");
    const deliveryDateEl = document.getElementById("delivery-date");

    if (orderDateEl && transitDateEl && deliveryDateEl) {

        orderDateEl.textContent = formatDate(orderDate);

        transitDateEl.textContent =
            formatDate(transitStart) + " - " + transitEnd.getDate();

        deliveryDateEl.textContent =
            formatDate(deliveryDate);

    }

    // ==========================
    // Product FAQ
    // ==========================

    const items = document.querySelectorAll(".accordion-item");

    if (items.length > 0) {
        items[0].classList.add("active");
    }

    items.forEach((item) => {

        const btn = item.querySelector(".accordion-toggle");

        if(btn){

            btn.addEventListener("click", function () {

                items.forEach((other) => {

                    if (other !== item) {
                        other.classList.remove("active");
                    }

                });

                item.classList.toggle("active");

            });

        }

    });

    // ==========================
    // Hair Oil Accordion
    // ==========================

    const hairItems = document.querySelectorAll(".accordindataset");

    hairItems.forEach(item => {

        const header = item.querySelector(".accordion-header");
        const icon = item.querySelector(".icon");

        if(header){

            header.addEventListener("click", function () {

                if (item.classList.contains("active")) {
                    item.classList.remove("active");

                    if(icon){
                        icon.textContent = "+";
                    }

                    return;
                }

                hairItems.forEach(other => {

                    other.classList.remove("active");

                    const otherIcon = other.querySelector(".icon");

                    if(otherIcon){
                        otherIcon.textContent = "+";
                    }

                });

                item.classList.add("active");

                if(icon){
                    icon.textContent = "−";
                }

            });

        }

    });

    

});


// ==========================
// Product Specification Tabs
// ==========================

function toggleTab(element) {

    const content = element.querySelector('.tab-content');
    const isActive = element.classList.contains('active');

    document.querySelectorAll('.tab').forEach(tab => {

        tab.classList.remove('active');

        const tabContent = tab.querySelector('.tab-content');

        if(tabContent){
            tabContent.style.display = 'none';
        }

    });

    if (!isActive) {

        element.classList.add('active');

        if(content){
            content.style.display = 'block';
        }

    }

}